export type OrderEventDocumentRef = {
  id: string
  documentKey: string
  orderEventId: number
  name: string
  traderId?: number
}

export function orderEventDocumentsByEvent(
  documents: readonly OrderEventDocumentRef[]
): Map<number, OrderEventDocumentRef[]> {
  const byEvent = new Map<number, OrderEventDocumentRef[]>()
  for (const document of documents) {
    const existing = byEvent.get(document.orderEventId)
    if (existing) existing.push(document)
    else byEvent.set(document.orderEventId, [document])
  }
  return byEvent
}
